import { StyleProvider } from '@ant-design/cssinjs';
import { App, ConfigProvider } from 'antd';
import { antdTheme } from './theme';
import * as styles from './overrides.module.css';
import * as React from 'react';

export const AntdWrapper: React.FC<{}> = ({ children }) => {
  const shadowDom = window.BUGHERD_REACT_APP_SIDEBAR_MOUNT.getRootNode();

  return (
    <StyleProvider container={shadowDom}>
      <ConfigProvider theme={antdTheme}>
        <App className={styles.antdOverrides}>{children}</App>
      </ConfigProvider>
    </StyleProvider>
  );
};
